import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import DropdownMenu from '../../../components/DropdownMenu'
import { fetchPromotions,insertPromotion } from "../../../services/promotions";
import EditButton from '../../../svgs/EditButton';
import SearchSvg from '../../../svgs/SearchSvg';
const limit = 999
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [isloading,setIsloading]=useState(false)
 

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem/limit)||1
    const [data,setData]=useState([])
    const page =  parseInt(searchParams.get('page'))||1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type')||'全部'
    //
    const handleSearchName=(e)=>{setSearchParams({page:1,name:e.target.value})}
    useEffect(() => {
        if(!props.token.isLogin)return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    },[searchParams,props.token])
    async function fetchData(){
        const filter = {}
        if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
 
        if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchPromotions(filter, {limit,skip:limit*(page-1),sort:{order:-1}})
        if(res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count/limit) || 1
        if(page > toPage) handleParamChange('page', 1)
    }

    function handleParamChange(key, val){
        searchParams.delete(key)
        if(val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item,index){
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    //add data 
    const [isAdding, setisAdding] = useState(false)
    const handleAddNewArticle=async ()=>{
        if(!isAdding.name) return alert('請輸入文章名稱')
        setIsloading(true)
        const res = await insertPromotion(props.token?.token,{
            name:isAdding.name,
            thumbnail:'',
            status:'draft',
            order:99,
            categories:[],
            tags:[],
            content:[],
        })
        if(res.errno) return alert('新增失敗')
        setIsloading(false)
        setisAdding(false)
        alert('新增成功')
        fetchData()
    }

    return(
        <div className="h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]" style={{overflowY:'scroll'}}>
             <div className="flex flex-row flex-wrap gap-[16px] w-full justify-start">
                {['全部','草稿','已公開'].map((item,index)=>
                    <div key={index} onClick={()=>selectFilter(item)} className="cursor-pointer text-[18px] px-[16px] py-[4px]  hover:opacity-80 items-center flex flex-row" style={{color:filterType===item?'#0F737E':'#00000099',fontWeight:filterType===item?'700':'400',borderBottom:filterType===item?'2px solid #0F737E':'none'}}>
                        {item}
                    </div>
                )
                }

            </div>

            <div className="w-full flex flex-row gap-[16px] mt-[16px] items-center justify-between">
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchName} placeholder="按文章名稱搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="text-[#6E604C]">Filter By </div>
                <DropdownMenu value={filterType} select={selectFilter} options={['全部','草稿','已公開']}/>
                <div className="flex flex-row flex-1 justify-end gap-[16px]">
                    <div onClick={()=>{setisAdding({})}} className="cursor-pointer hover:opacity-80">
                        <NewArticleButton/>
                    </div>
                </div>
            </div>
            
            {/* <div className="w-full flex flex-row gap-[16px] mt-[16px] border-[1px] border-[white] p-[16px] rounded-[8px] bg-[#ffffff90]">
                <div className="font-[700] text-[20px]">
                    文章管理
                </div>
            </div> */}

            <div className="flex flex-row w-full gap-[16px] mt-[16px] flex-wrap">
                {data.map((item,index)=>{
                    return(
                        <div key={index} className="w-[400px] relative border-[1px] border-[white] gap-[6px] rounded-[24px] flex justify-between items-center flex-col bg-[#ffffff40] pb-[24px]" style={{height:undefined,aspectRatio:1,overflow:'hidden'}}>
                            <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)'}}/>
                            {item?.thumbnail?
                                <img src={item?.thumbnail} className="rounded-t-[16px] z-[2]" style={{width:'100%',objectFit:'cover',height:undefined,aspectRatio:600/300}}/>
                                :<div/>
                            }
                            <div className="text-[18px] font-[700] z-[2] text-center">{item?.name}</div>
                            <div onClick={navigateTo(`/cms/contents/promotions/${item._id}`)} className="cursor-pointer hover:opacity-80 z-[2]">
                                <EditButton/>
                            </div>
                        </div>
                    )
                })}
            </div> 

            {isAdding &&
                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-[#00000080] z-[9999]">
                    <div className="relative w-[400px] bg-white rounded-[16px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[20px] font-[700]">新增文章</div>
                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">文章名稱</div>
                        <input onChange={(e)=>{setisAdding({...isAdding,name:e.target.value})}} placeholder="請輸入文章名稱" className="p-[4px] rounded-[4px] w-full border-[1px] border-[black]"/>
                        <div onClick={()=>{setisAdding(false)}} className="absolute top-[16px] right-[16px] cursor-pointer text-[black] text-[12px] font-[700] p-[4px] hover:opacity-80 items-center flex flex-row" >
                            X
                        </div>
                        <div onClick={handleAddNewArticle} className="cursor-pointer text-[#6E604C] text-[12px] font-[700] px-[24px] py-[4px] rounded-[4px] bg-[#6E604C30] hover:opacity-80 items-center flex flex-row mt-[16px]" style={{border:'1px solid #6E604C'}}>
                            確認
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)



  const NewArticleButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={159}
      height={40}
      fill="none"
      {...props}
    >
      <rect width={159} height={40} fill="url(#anana)" rx={7} />
      <path
        fill="#fff"
        d="M60.266 19.508h3.023v1.71h-3.023v3.009h-1.711v-3.008H55.53v-1.711h3.024V16.46h1.71v3.047Zm17.41-1.812h5.984v1.776h-5.984v-1.776ZM69.004 14h7.216v1.552h-7.216V14Zm-.144 6.368h7.344v1.616H68.86v-1.616Zm-.048-2.8h7.536v1.568h-7.536v-1.568Zm11.456.912h1.872v8.88h-1.872v-8.88Zm-8.576-5.936h1.856v2.144h-1.856v-2.144Zm0 6.496h1.856v8.368h-1.856V19.04Zm5.12-5.376 2.24.64c-.01.139-.144.23-.4.272v4.704c0 .597-.032 1.253-.096 1.968-.053.704-.165 1.43-.336 2.176-.17.736-.421 1.45-.752 2.144a7.404 7.404 0 0 1-1.312 1.904 1.925 1.925 0 0 0-.368-.48 7.53 7.53 0 0 0-.512-.496 2.147 2.147 0 0 0-.496-.336c.47-.49.838-1.019 1.104-1.584.278-.576.48-1.168.608-1.776a10.7 10.7 0 0 0 .256-1.808c.043-.608.064-1.19.064-1.744v-5.584Zm5.232-1.088 1.536 1.392c-.544.245-1.136.47-1.776.672-.64.203-1.296.384-1.968.544-.661.15-1.301.283-1.92.4a6.207 6.207 0 0 0-.256-.736 5.063 5.063 0 0 0-.352-.72 37.775 37.775 0 0 0 1.744-.432c.587-.17 1.136-.352 1.648-.544.523-.192.97-.384 1.344-.576Zm-8.624 9.472c.118.064.288.181.512.352.235.17.48.357.736.56.256.192.486.373.688.544.214.16.374.277.48.352l-1.12 1.376a14.9 14.9 0 0 0-.496-.544 9.306 9.306 0 0 0-.64-.672 36.004 36.004 0 0 0-.656-.64 14.801 14.801 0 0 0-.544-.496l1.04-.832Zm-3.616-6.256 1.488-.352c.139.288.262.613.368.976.107.352.176.656.208.912l-1.552.432a5.486 5.486 0 0 0-.176-.944 5.5 5.5 0 0 0-.336-1.024Zm3.984-.384 1.712.336c-.15.363-.293.715-.432 1.056-.138.33-.266.613-.384.848l-1.536-.32c.075-.181.155-.384.24-.608.086-.224.166-.448.24-.672.075-.235.128-.448.16-.64Zm-2.08 5.888 1.344.512a14.613 14.613 0 0 1-.928 1.744 13.997 13.997 0 0 1-1.184 1.616 9.481 9.481 0 0 1-1.28 1.264 6.517 6.517 0 0 0-.576-.704 5.406 5.406 0 0 0-.672-.656 7.963 7.963 0 0 0 1.248-1.008c.416-.416.8-.859 1.152-1.328.363-.48.662-.96.896-1.44Zm23.52-5.328 2.048.608c-.672 1.92-1.541 3.584-2.608 4.992a15.336 15.336 0 0 1-3.808 3.568c-1.461.96-3.152 1.744-5.072 2.352a3.416 3.416 0 0 0-.32-.608c-.15-.235-.304-.47-.464-.704a4.482 4.482 0 0 0-.432-.56c1.846-.49 3.462-1.157 4.848-2a12.743 12.743 0 0 0 3.52-3.136c.96-1.259 1.723-2.763 2.288-4.512Zm-6.192.128a14.992 14.992 0 0 0 2.256 4.272 13.128 13.128 0 0 0 3.552 3.2c1.419.875 3.072 1.525 4.96 1.952-.15.15-.314.341-.496.576-.17.235-.336.47-.496.704-.16.245-.288.459-.384.64-1.994-.512-3.712-1.259-5.152-2.24a14.573 14.573 0 0 1-3.664-3.616c-.992-1.419-1.824-3.056-2.496-4.912l1.92-.576Zm-4.176-1.152h14.656v1.872H84.86v-1.872Zm6.304-2.544h1.968v3.68h-1.968V12.4Zm9.696 11.856h14.608v1.536H100.86v-1.536Zm6.24-1.328h2.032v4.496H107.1v-4.496Zm-2.656-1.408v.752h7.344v-.752h-7.344Zm0-1.936v.736h7.344v-.736h-7.344Zm-1.872-1.28h11.184v5.248h-11.184v-5.248Zm-.64-4.832h12.528v1.504h-12.528v-1.504Zm-1.008 2.672h14.464v1.52h-14.464v-1.52ZM107.1 12.4h2.032v2.144H107.1V12.4Zm3.264 2.24 2.064.336c-.17.33-.33.635-.48.912-.149.277-.288.517-.416.72l-1.808-.336c.075-.16.15-.336.224-.528.086-.192.166-.384.24-.576.075-.203.134-.379.176-.528Zm-6.32.384 1.856-.32c.16.235.304.496.432.784.128.277.219.533.272.768l-1.952.384a3.901 3.901 0 0 0-.224-.784 5.98 5.98 0 0 0-.384-.832Z"
      />
      <defs>
        <linearGradient
          id="anana"
          x1={79.5}
          x2={79.5}
          y1={0}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C866B" />
          <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
        </linearGradient>
      </defs>
    </svg>
  )